import { computed, inject, Injectable, signal } from "@angular/core";
import { AuthorizationService } from "./authorization.service";
import { MODULES_CONFIG } from "../config/modules.config";
import { ModulePage } from "../models/module.model";

export interface CommandPaletteGroup {
  readonly id: string;
  readonly label: string;
  readonly path: string;
  readonly pages: ModulePage[];
}

@Injectable({ providedIn: "root" })
export class CommandPaletteService {
  private readonly _authz = inject(AuthorizationService);

  private readonly _isOpen = signal(false);
  readonly isOpen = this._isOpen.asReadonly();

  open(): void {
    this._isOpen.set(true);
  }

  close(): void {
    this._isOpen.set(false);
  }

  toggle(): void {
    this._isOpen.update((v) => !v);
  }

  readonly navigationGroups = computed((): CommandPaletteGroup[] => {
    const canAccessModule = this._authz.canAccessModule();
    const canAccessPage = this._authz.canAccessPage();

    return MODULES_CONFIG.filter((module) => canAccessModule(module.id))
      .map(
        (module): CommandPaletteGroup => ({
          id: module.id,
          label: module.label,
          path: module.path,
          pages: module.pages.filter((page) =>
            canAccessPage(module.id, page.id),
          ),
        }),
      )
      .filter((group) => group.pages.length > 0);
  });
}
